import * as React from "react"
const SvgComponent = (props:any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={165}
    height={23}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <mask
        id="b"
        width={16}
        height={16}
        x={0}
        y={7}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M.776 7.528h14.64v14.635H.776V7.528Z" />
      </mask>
      <g mask="url(#b)">
        <path
          fill="#0080FF"
          fillRule="evenodd"
          d="m1.481 9.696 1.42-1.421c.94-.94 2.476-.94 3.411 0l8.356 8.35c.94.94.94 2.476 0 3.416l-1.421 1.416c-.94.94-2.475.94-3.41 0L1.48 13.106a2.415 2.415 0 0 1 0-3.41Z"
          clipRule="evenodd"
        />
      </g>
      <mask
        id="c"
        width={13}
        height={12}
        x={5}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M5.836.204H17.57v11.17H5.836V.204Z" />
      </mask>
      <g mask="url(#c)">
        <path
          fill="#0080FF"
          fillRule="evenodd"
          d="m7.009 4.393 3.41-3.41a2.02 2.02 0 0 1 2.841 0l3.41 3.41a2.011 2.011 0 0 1 0 2.842l-3.41 3.41a2.011 2.011 0 0 1-2.841 0l-3.41-3.41a2.011 2.011 0 0 1 0-2.842Z"
          clipRule="evenodd"
        />
      </g>
      <mask
        id="d"
        width={11}
        height={12}
        x={12}
        y={6}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M12.876 6.68h9.89v10.56h-9.89V6.68Z" />
      </mask>
      <g mask="url(#d)">
        <path
          fill="#0080FF"
          fillRule="evenodd"
          d="m13.629 11.868 4.262-4.262a1.452 1.452 0 0 1 2.05 0l2.502 2.502c.563.56.563 1.48 0 2.044l-4.263 4.263a1.452 1.452 0 0 1-2.049 0l-2.502-2.503a1.447 1.447 0 0 1 0-2.044Z"
          clipRule="evenodd"
        />
      </g>
      <path
        fill="#111"
        d="M33.62 21.102c3.382 0 5.426-2.241 5.426-4.72 0-1.12-.449-2.068-1.16-2.842-.925-1.013-2.433-1.683-4.244-2.132-2.543-.646-3.598-1.49-3.598-3.016 0-1.769 1.678-2.869 3.488-2.869 2.242 0 3.296 1.293 3.86 2.695L38.9 7.38c-.757-2.007-2.521-3.515-5.322-3.515-2.8 0-5.303 1.723-5.303 4.61 0 2.352 1.577 3.837 5.042 4.676 2.498.605 3.923 1.595 3.923 3.36 0 1.769-1.64 2.933-3.62 2.933-2.306 0-3.511-1.293-4.309-3.254l-1.53.797c.971 2.562 2.887 4.116 5.839 4.116ZM42.145 20.928h1.678v-5.752h.064l5.734 5.752h2.347l-6.335-6.334 6.055-5.17h-2.392l-5.473 4.675V3.369h-1.678v17.56ZM53.47 5.308c0 .692.563 1.251 1.251 1.251.71 0 1.27-.559 1.27-1.25 0-.711-.56-1.27-1.27-1.27-.688 0-1.251.559-1.251 1.27Zm2.113 15.62V9.424h-1.7v11.504h1.7ZM61.072 20.928V3.37h-1.7v17.56h1.7ZM66.562 20.928V3.37h-1.7v17.56h1.7ZM86.637 5.698V4.062H76.08v16.866h10.643v-1.636H77.85v-6.119h8.035v-1.636H77.85v-5.84h8.787ZM90.38 9.424h-1.852l4.89 11.504h1.788l4.914-11.504h-1.788l-4.01 9.653-3.942-9.653ZM109.441 14.292h-3.19c-2.045 0-4.543.82-4.543 3.318v.129c0 1.938 1.527 3.382 3.855 3.382 1.723 0 2.975-.797 3.878-2.218h.023v2.026h1.636v-7.434c0-.363-.087-1.27-.344-1.893-.559-1.27-1.769-2.37-4.203-2.37-2.324 0-3.919 1.141-4.716 2.97l1.379.78c.56-1.21 1.527-2.265 3.296-2.265 1.916 0 2.929.949 2.929 2.8v.775Zm0 1.38v.407c0 2.113-1.531 3.557-3.575 3.557-1.38 0-2.48-.733-2.48-2.026 0-1.549 1.618-1.938 2.846-1.938h3.209ZM116.437 20.928V3.37h-1.7v17.56h1.7ZM121.755 9.424h-1.659v7.109c0 2.695 1.531 4.61 4.354 4.61 1.677 0 3.039-.756 3.942-2.328v2.113h1.636V9.424h-1.659v6.573c0 2.044-1.421 3.616-3.424 3.616-2.131 0-3.19-1.444-3.19-3.488v-6.7ZM140.77 14.292h-3.19c-2.044 0-4.542.82-4.542 3.318v.129c0 1.938 1.526 3.382 3.855 3.382 1.723 0 2.974-.797 3.877-2.218h.023v2.026h1.636v-7.434c0-.363-.087-1.27-.343-1.893-.559-1.27-1.769-2.37-4.203-2.37-2.324 0-3.919 1.141-4.717 2.97l1.38.78c.559-1.21 1.526-2.265 3.295-2.265 1.916 0 2.929.949 2.929 2.8v.775Zm0 1.38v.407c0 2.113-1.531 3.557-3.575 3.557-1.379 0-2.479-.733-2.479-2.026 0-1.549 1.618-1.938 2.846-1.938h3.208ZM150.094 21.015c.298 0 .968-.064 1.311-.174v-1.398c-.256.064-.664.082-1.031.082-1.274 0-1.875-.577-1.875-1.613v-7.003h2.906V9.424h-2.906V6.105h-1.659v3.319h-2.131v1.485h2.131v7.044c0 1.682.752 3.062 3.254 3.062ZM164.415 15.694c.022-.174.022-.366.022-.559 0-3.364-1.874-5.903-5.431-5.903-3.231 0-5.601 2.8-5.601 5.922 0 3.318 2.503 5.967 5.84 5.967 2.025 0 3.877-1.054 4.867-2.97l-1.247-.82c-.646 1.315-1.961 2.305-3.643 2.305-2.237 0-3.983-1.7-4.112-3.941h9.305Zm-9.286-1.42c.279-1.92 1.874-3.58 3.877-3.58 2.2 0 3.511 1.49 3.726 3.58h-7.603Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h165v22.89H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgComponent
